import { ajax as ajaxJson } from 'rxjs/ajax';

export function ajax(config) {
    config.url = encodeURI(config.url);
    return ajaxJson(config)
}
